import {Component, Input} from '@angular/core';
import {Severity} from '../../../../types/severity';
import {AgencyService} from '../../../../services/agency.service';

@Component({
  selector: 'mc-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  @Input() severity: Severity = 'primary';

  constructor(public agencyService: AgencyService) {}
}
